
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-hub/sub-category",
      function () {
        return require("private-next-pages/content-hub/sub-category.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-hub/sub-category"])
      });
    }
  